export enum SaleType {
  OFFER = 'Offer',
  BOUGHT = 'Bought',
  SALE = 'Sale',
  UNDEFINED = 'Undefined',
}
